import React, { useState } from 'react'
import "antd/dist/antd.css";
import styles from './MainLayout.module.css';
import BoardHeader from '../Header';
import Dock from '../Dock';
import SidePod from '../Dock/SidePod';
import Board from '../Board';
import { useParams } from "react-router-dom";
import { ChatBox } from '../ChatBox/ChatBox';
import MouseContainer from '../mousecontainer';
import PropertiesModal from '../PropertiesModal';
import { useCanvas } from '../../context/canvasContext';
import OfflineStatus from '../OfflineStatus';
import { useDocument } from '../../context/documentInfoContex';
import DocumentDataConflictModal from '../ConflictModal/index.js';

const MainLayout = () => {
    const { id } = useParams();
    const { isConflictModalVisible, setIsConflictModalVisible, conflictPreviewVerion } = useDocument();
    const hideMenu = new URL(window.location.href).searchParams.get("hideMenu");
    const [contentLoading, setContentLoading] = useState(true);
    const { isPropertiesDrawerOpen, setIsPropertiesDrawerOpen } = useCanvas();

    return (
        <div>
            {!contentLoading && !conflictPreviewVerion && <BoardHeader />}
            <div className={styles.board}>
                {!contentLoading && !hideMenu && (
                    <div className={styles.leftTools}>
                        <Dock />
                        <SidePod />
                    </div>
                )}
                <div>
                    <Board contentLoading={contentLoading} setContentLoading={setContentLoading} />
                    <PropertiesModal
                        isOpen={isPropertiesDrawerOpen}
                        onClose={() => setIsPropertiesDrawerOpen(false)}
                    />
                </div>
            </div>
            {!conflictPreviewVerion && (
                <>
                    <ChatBox id={id} />
                    <MouseContainer id={id} />
                </>
            )}
            <OfflineStatus />
            <DocumentDataConflictModal
                isConflictModalVisible={isConflictModalVisible}
                setIsConflictModalVisible={setIsConflictModalVisible}
            />
        </div>
    )
}

export default MainLayout;
